/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import InfoImg1 from 'static/main/section7_1.png';
import InfoImg2 from 'static/main/section7_2.png';

const Section7 = () => {
  const { mq } = useTheme();
  const navigate = useNavigate();

  const session4Style = css`
    background: #87c77f;
    .container {
      margin: 0 auto;
      .info {
        display: flex;
        li {
          flex: 1;
          padding: 82px 85px 82px 100px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          h3 {
            font-size: 32px;
            font-weight: 700;
            line-height: 48px;
          }
          p {
            font-size: 20px;
            font-weight: 400;
            line-height: 30px;
          }
          &:nth-of-type(1) {
            color: #f9744a;
            background-color: #ffdfc5;
            img {
              width: 233px;
            }
          }
          &:nth-of-type(2) {
            color: #6079ff;
            background-color: #d0d8ff;
            img {
              width: 195px;
            }
          }
        }
      }
    }
    ${mq.mobile} {
      .container {
        .info {
          flex-direction: column;
          li {
            padding: 34px 0px;
            flex-direction: column-reverse;
            text-align: center;
            h3 {
              font-size: 18px;
              font-weight: 700;
              line-height: 28px;
              margin-top: 16px;
            }
            p {
              font-size: 12px;
              font-weight: 400;
              line-height: 18px;
            }
            &:nth-of-type(1) {
              img {
                width: 93px;
              }
            }
            &:nth-of-type(2) {
              img {
                width: 77px;
              }
            }
          }
        }
      }
    }
  `;
  return (
    <div css={session4Style}>
      <div className="container">
        <ul className="info">
          <li>
            <div
              className="text"
              onClick={() => window.open('https://guide.mallpie.kr', '_blank')}
            >
              <h3>몰파이 이용가이드</h3>
              <p>
                몰파이가 어려우세요?
                <br />몰 관리 및 입점사(셀러)를 위한 가이드
              </p>
            </div>
            <img src={InfoImg1} alt="인포이미지1" />
          </li>
          <li>
            <div className="text" onClick={() => navigate('/business/shop')}>
              <h3>기업/단체를 위한 채널링 커머스</h3>
              <p>
                폐쇄몰, 복지몰 등 비즈니스용 쇼핑몰이 필요하신가요?
                <br />
                비즈니스를 위한 커머스 서비스를 제공해드립니다.
              </p>
            </div>
            <img src={InfoImg2} alt="인포이미지1" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Section7;
